import React, { useContext } from 'react';
import { Container } from '@pwskills/rachnaui';
import CategoryPageContext from '@/context/CategoryPageContext';
import Faqs from '@/components/common/Faqs';

const Faq = () => {
  const { categoryDetails } = useContext(CategoryPageContext);
  const { faq } = categoryDetails || {};

  return (
    <div className="bg-white">
      {faq && faq?.length > 0 && (
        <Container className="py-8 medium:py-12 large:!py-14 ">
          <Faqs
            faqsList={faq}
            classes="flex justify-start large:!justify-center regular:!w-full !text-6 !leading-9  large:!text-8 large:!leading-10 "
            showViewAllButton={false}
            wrapperClass="[&>header]:!pb-[12px] [&>header]:medium:!pb-[32px] [&>header]:large:!pb-[58px]"
          />
        </Container>
      )}
    </div>
  );
};

export default Faq;
